module.exports = __webpack_public_path__ + "img/tool_icon_0.f83a5c8.png";